import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import React, { useContext } from 'react';
import { OverlayTriggerStateContext, Dialog } from 'react-aria-components';

const dialog = "_dialog_mc0fl_1";
const styles = {
	dialog: dialog
};

const DialogBase = (_a) => {
  var { children, className, style } = _a, props = __rest(_a, ["children", "className", "style"]);
  const state = useContext(OverlayTriggerStateContext);
  const close = React.useCallback(() => state === null || state === void 0 ? void 0 : state.close(), [state]);
  return jsx(Dialog, Object.assign({ "aria-label": props["aria-label"], "aria-labelledby": props["aria-labelledby"], className: clsx(styles.dialog, className), "data-zds": true, style }, props, { children: typeof children === "function" ? children({ close }) : children }));
};

export { DialogBase };
//# sourceMappingURL=DialogBase.es.js.map
